import React from "react";
import { Link } from "react-router-dom";

// Header con el logo de Mundo Piloto. Sin menú por defecto; lo que se pase como children va a la derecha
// (por ejemplo un enlace "Inicio"). grande: la altura del Figma original, para páginas sin hero debajo.
export const HeaderAsociacion = ({ grande = false, children }) => {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: grande ? "clamp(64px, 8.8vw, 113px)" : "clamp(48px, 5vw, 68px)",
        // 3,4% en pantallas hasta 1280 px; en las más anchas, el mismo margen pero medido desde el contenido centrado
        padding: "0 max(3.4%, calc((100% - 1280px) / 2 + 43.5px))",
        backgroundColor: "#06192A",
        boxSizing: "border-box",
      }}
    >
      <Link to="/" style={{ display: "flex", alignItems: "center", height: "100%" }}>
        <img
          src="/img/logo-mundo-piloto.png"
          alt="Mundo Piloto"
          style={{ height: grande ? "68%" : "84%", objectFit: "contain" }}
        />
      </Link>
      {children}
    </header>
  );
};
